import type { OrgRole } from '@core/types';

export const ROLE_LABEL: Record<OrgRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  senior_recruiter: 'Senior Recruiter',
  junior_recruiter: 'Junior Recruiter',
  viewer: 'Viewer',
};
